import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { Fleet } from "@/components/sections/Fleet";
import { Pricing } from "@/components/sections/Pricing";
import { Features } from "@/components/sections/Features";
import { About } from "@/components/sections/About";
import { Testimonials } from "@/components/sections/Testimonials";
import { Contact } from "@/components/sections/Contact";
import { useBooking } from "@/context/BookingContext";

export default function Home() {
  const { openBooking } = useBooking();
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    if (params.get("book") === "1") {
      openBooking("");
      params.delete("book");
      setParams(params, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-[#050505] text-white min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Fleet />
        <Pricing />
        <Features />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
